export default __webpack_public_path__ + "static/media/error-boundary-image.3044d08f.png";